export default __webpack_public_path__ + "static/holaspirit-logo.eb00e752.svg";